<!-- Location Map -->
<div>
    <agm-map [latitude]="lat" [longitude]="long" [zoom]="15">
        <agm-marker [latitude]="lat" [longitude]="long"></agm-marker>
    </agm-map>
</div>
